import React from 'react';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';

import NewInput from 'components/atoms/NewInput';
import NewRadioGroup from 'components/molecules/NewRadioGroup';
import Modal from 'components/organisms/NewModal';

const useStyles = makeStyles((theme) => ({
  modalFilterWrap: {
    minWidth: 200,
    '& > div:first-child': { marginBottom: 10 },
    '& > div': { display: 'flex', '& > p': { lineHeight: '10px' } },
    '& b': { display: 'inline-block' },
  },
}));

const StatisticsModal = (props) => {
  const { modal, handleModalClose, getParam, handleSubmit, list } = props;
  const {
    open,
    code,
    headerOpen,
    cancelBtnOpen,
    cancelBtnTitle,
    modalTitle,
    confirmBtnTitle,
    params,
  } = modal;
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Modal
      open={open}
      headerOpen={headerOpen}
      headerTitle={modalTitle}
      handleClose={handleModalClose}
      confirmBtnTitle={confirmBtnTitle}
      cancelBtnOpen={cancelBtnOpen}
      cancelBtnTitle={cancelBtnTitle}
      confirmOnClick={handleSubmit}
      useForm={code === 'add' || code === 'edit'}
    >
      {(code === 'add' || code === 'edit') && (
        <>
          <tr>
            <th>
              <b>{t('광고주 ID')}</b>
            </th>
            <td>
              <NewInput
                type="tableInput"
                callBack={getParam}
                params={params}
                name="cafe24Id"
                value={params.adverId}
                disabled
              />
            </td>
          </tr>
          <tr>
            <th>
              <b>{t('카페24 ID')}</b>
            </th>
            <td>
              <NewInput
                type="tableInput"
                callBack={getParam}
                params={params}
                name="cafeId"
                value={params.cafeId}
              />
            </td>
          </tr>
          <tr>
            <th>
              <b>{t('카페24 PW')}</b>
            </th>
            <td>
              <NewInput
                type="tableInput"
                callBack={getParam}
                params={params}
                name="cafePw"
                value={params.cafePw}
              />
            </td>
          </tr>
          <tr>
            <th>{t('앱 KEY')}</th>
            <td>
              <NewInput
                type="tableInput"
                callBack={getParam}
                params={params}
                name="appId"
                value={params.appId}
              />
            </td>
          </tr>
          <tr>
            <th>{t('앱 SECRET')}</th>
            <td>
              <NewInput
                type="tableInput"
                callBack={getParam}
                params={params}
                name="appPw"
                value={params.appPw}
              />
            </td>
          </tr>
          <tr>
            <th>{t('권한')}</th>
            <td>
              <NewInput
                type="tableInput"
                callBack={getParam}
                params={params}
                name="apiAuth"
                value={params.apiAuth}
              />
            </td>
          </tr>
          <tr>
            <th>{t('카페24 인증토큰')}</th>
            <td>
              <NewInput
                type="tableInput"
                callBack={getParam}
                params={params}
                name="certTkn"
                value={params.certTkn}
                disabled
              />
            </td>
          </tr>
          <tr>
            <th>{t('카페24 리플레쉬토큰')}</th>
            <td>
              <NewInput
                type="tableInput"
                callBack={getParam}
                params={params}
                name="isgnTkn"
                value={params.isgnTkn}
                disabled
              />
            </td>
          </tr>
          <tr>
            <th>{t('카페24 토큰 인증 여부')}</th>
            <td>
              <NewInput
                type="tableInput"
                callBack={getParam}
                params={params}
                name="certTknYn"
                value={params.certTknYn}
                disabled
              />
            </td>
          </tr>
          <tr>
            <th>{t('토큰발행 코드값')}</th>
            <td>
              <NewInput
                type="tableInput"
                callBack={getParam}
                params={params}
                name="codeTkn"
                value={params.codeTkn}
                disabled
              />
            </td>
          </tr>
        </>
      )}
      {code === 'soldOutEdit' && (
        <div className={classes.modalFilterWrap}>
          <div>
            <b style={{ width: 120 }}>{t('선택한 광고주')} :</b>
            {params.adverId}
          </div>
          <div>
            <p>
              <b style={{ width: 100 }}>{t('품절사용 여부')} :</b>
            </p>
            <NewRadioGroup
              params={params}
              labelKey="label"
              valueKey="value"
              optionList={list.trxYn}
              handleGetValue={getParam}
              name="trxYn"
              style={{ height: 30 }}
            />
          </div>
          <div>
            <p>
              <b style={{ width: 100 }}>{t('품절구분')} :</b>
            </p>
            <NewRadioGroup
              params={params}
              labelKey="label"
              valueKey="value"
              // selectedValue={optionSelectedValue}
              optionList={list.batKnd}
              handleGetValue={getParam}
              name="batKnd"
              style={{ height: 30 }}
            />
          </div>
        </div>
      )}
    </Modal>
  );
};

export default StatisticsModal;
